import React, { ReactElement } from 'react';
import { Icon, ICON_NAME } from 'b2b-components/theme/components/Icon';
import { createKey } from 'b2b-apps/shop/common/utils/key/key';
import { DocumentType } from 'b2b-apps/shop/product/redux/products/full/types';
import { getCdnDocumentUrl } from 'b2b-apps/shop/routes/utils/url';
import { ComponentType, Props } from './';
import './ProductDocuments.scss';

const ProductDocuments: ComponentType = ({ label, documents }: Props): ReactElement => {
  const values = documents.map((document: DocumentType) => (
    <tr key={createKey(document.name, document.size)}>
      <td>
        <Icon name={ICON_NAME.pdfFile} />{' '}
        <a
          href={getCdnDocumentUrl(document.uri)}
          target="_blank"
          rel="noopener noreferrer"
        >
          {document.name}
        </a>{' '}
        ({document.size}MB)
      </td>
    </tr>
  ));

  return (
    <div className="ProductDocuments">
      {label && <div className="ProductDocuments-Label">{label}</div>}
      <table className="cds-Table cds-Table--Specs">
        <tbody>{values}</tbody>
      </table>
    </div>
  );
};

export { ProductDocuments };
